///<reference path="./smart-mover.models.ts"/>
///<reference path="../../../baseClasses/dataMaintenance.interface.ts"/>
///<reference path="collection-model.ts"/>
///<reference path="collection-category.ts"/>
///<reference path="../../../common/event-emitter.ts"/>


module Meevo.Components.Controls.SmartMover {


    import MeevoEventEmitter = Meevo.Components.Common.MeevoEventEmitter;

    export class SmartMoverCollectionBase<T> extends MeevoEventEmitter implements ICollectionBase<T> {
        private updateFromInside: boolean;
        private initialized: boolean;

        protected modelOptions: IModelOptions<T>;
        protected dataService: Meevo.Components.BaseClasses.IDataService;
        responseList: T[];
        protected filteredModelsList: CollectionModel<T>[];
        protected filters: IInteractiveFilter[];
        protected moverHidden: boolean;
        protected readonly allSelectedValue?: SmartMoverHiddenValue;

        public allModelsList: CollectionModel<T>[];
        public populateClass: ICollectionPopulate;
        public childCollection?: ICollectionBase<any>;
        public parentCollection?: ICollectionBase<any>;

        protected get smartMoverHiddenValue(): SmartMoverHiddenValue {
            return this.options.hiddenValue || SmartMoverHiddenValue.Ids;
        }

        protected get CategoryModel() {
            return this.options.CategoryModel || CollectionCategory;
        }

        protected get CollectionModel() {
            return this.options.SmartMoverModel || SmartMoverModel;
        }

        protected get emptyCollectionValue() {
            return [];
        }

        get allSelected(): boolean {
            return this.selectedModelsLength === this.models.length;
        }

        get value(): ModelValueType[] {
            return this.selectedModels.length === 0 ? this.emptyCollectionValue : this.selectedModels.map((row) => row.id);
        }

        /**
         * The list of models filtered by the related filters
         */
        get models() {
            return this.moverHidden ? this.allModelsList : this.filteredModelsList;
        }

        /**
         * All Collection selected
         */
        get selected(): boolean {
            const models = this.getLowLevelModels();

            return models.filter((model) => model.selected).length === models.length;
        }

        /**
         * The list of selected models
         */
        get selectedModels(): CollectionModel<T>[] {
            return this.models.filter((model) => model.selected);
        }

        /**
         * The length of the selected models
         */
        get selectedModelsLength(): number {
            return this.selectedModels.length;
        }

        constructor(public connectedModel: ModelValueType[], items: T[] = [], protected options: ICollectionOptions<T> = {} as ICollectionOptions<T>) {
            super();

            this.modelOptions = {
                displayNameKey: options.displayNameKey || 'displayName',
                idKey: options.idKey || 'id',
                collection: this,
                $filter: options.$filter,
                showInactiveLabel: options.showInactiveLabel,
                inactiveLabel: options.inactiveLabel
            } as IModelOptions<T>;
            this.filteredModelsList = [];
            this.responseList = [];
            this.allModelsList = [];
            this.filters = [];

            this.initialized = false;

            if (items.length) {
                this.handleResponse(items);
            }
        }

        public setMoverVisibility(hidden: boolean): void {
            this.moverHidden = hidden;

            if (this.childCollection) {
                this.childCollection.setMoverVisibility(hidden);
            }
        }

        public resetCollection(data: ModelValueType[]): void {
            this.updateFromInside = true;
            if (this.connectedModel != null) {
                this.connectedModel.length = 0;
                this.connectedModel.push(...data);
            }

            if (this.smartMoverHiddenValue !== SmartMoverHiddenValue.Ids && typeof this.options.smartMoverHidden === 'function' && this.options.smartMoverHidden()) {
                this.connectedModel.length = 0;
            } else if(this.allSelected && this.allSelectedValue) {
                switch (this.allSelectedValue) {
                    case SmartMoverHiddenValue.EmptyArray:
                        this.connectedModel.length = 0;
                        break;
                }
            }

            setTimeout(() => this.updateFromInside = false);
        }

        public pushObjects(objs: T[]): CollectionModel<T>[] {
            const models = this.mapResponse(objs);
            this.allModelsList.push(...models);

            return models;
        }

        /**
         * Transforms simple objects from response to the models
         * @param list
         */
        protected mapResponse(list: T[]): CollectionModel<T>[] {
            return list
                .map((row) => {
                    const model = !!this.childCollection ?
                        new this.CategoryModel(row, {
                            ...this.modelOptions
                        }) :
                        new this.CollectionModel(row, {
                            ...this.modelOptions
                        });

                    const previousModel = this.allModelsList
                        .find((previousModel) => previousModel.id === model.id);

                    if (previousModel) {
                        model.selected = previousModel.selected;
                    }

                    return model;
                });
        }

        /**
         * If the collection has been updated from the outside of the control this method will select the necessary rows
         * @param modelValues
         */
        public updateCollectionFromModel(modelValues: ModelValueType[]): void {
            const selectModelBy = this.options.criteria && this.options.criteria['selectModelBy'] || null;
            if (angular.isFunction(selectModelBy)) {
                for (const model of this.allModelsList) {
                    model.selected = selectModelBy(model['attributes']);
                }
            } else {
                for (const model of this.allModelsList) {
                    model.selected = this.modelIsSelected(model, modelValues);
                }
            }
            // Filters depend on selected state so re-filter after
            this.filterList();
        }

        protected modelIsSelected(model: CollectionModel<T>, modelValues: ModelValueType[]): boolean {
            return modelValues.indexOf(model.id) !== -1;
        }

        /**
         * Method receives the response and makes the necessary things
         * @param items
         */
        public handleResponse(items: T[]): void {
            this.responseList = items;
            this.allModelsList = this.mapResponse(items);
            this.filteredModelsList = this.allModelsList;

            if (!this.initialized && !!this.options.defaultValue && this.options.defaultValue.length) {
                this.emit(MODEL_UPDATED_OUTSIDE);
                this.updateCollectionFromModel(this.options.defaultValue);
                this.initialized = true;
            }
            else {
                this.filterList();
            }
        }

        /**
         * Set the necessary watchers to the model.
         * - watch the collection models and updates the model from the outside.
         * - watch the model from outside and updates the models in the collection
         * @param scope
         */
        public setWatchers(scope: ng.IScope) {

            scope.$watch(() => this.moverHidden, (hidden?: boolean) => {
                if (hidden === false) {
                    this.filterList();
                }
            });

            scope.$watch(() => this.selectedModelsLength, (newValue, oldValue) => {
                if (typeof newValue !== 'number' || newValue === oldValue && newValue === this.connectedModel.length) return;

                this.resetCollection(this.value);
            });

            if (this.smartMoverHiddenValue !== SmartMoverHiddenValue.Ids && typeof this.options.smartMoverHidden === 'function') {
                scope.$watch(() => this.options.smartMoverHidden(), (newValue: boolean) => {

                    if (newValue) {
                        switch (this.smartMoverHiddenValue) {
                            case SmartMoverHiddenValue.EmptyArray:
                                this.resetCollection([]);
                                break;
                        }
                    } else if (this.connectedModel.length === 0) {
                        this.resetCollection(this.value);
                    }
                });
            } else if (!this.childCollection) {
                // watchers used only for the lowest collection level

                scope.$watch(() => this.connectedModel, (newValue: ModelValueType[], oldValue: ModelValueType[]) => {
                    if (this.updateFromInside ||
                        !newValue ||
                        !(newValue instanceof Array) ||
                        !(oldValue instanceof Array) ||
                        oldValue.length === newValue.length && newValue.length === 0
                    ) {
                        return;
                    }

                    this.emit(MODEL_UPDATED_OUTSIDE);
                    this.updateCollectionFromModel(newValue);
                }, true);
            }
        }

        /**
         * Updates the `selected` property for every model in the collection
         * @param selected
         */
        public setSelectedValue(selected: boolean): void {
            if (this.childCollection) {
                this.childCollection.setSelectedValue(selected);
            }

            this.models.forEach((model) => {
                model.selected = selected;
            });
            this.resetCollection(this.value);
        }

        public setDisabled(disabled: boolean): void {
            this.models.forEach((model) => {
                model.disabled = disabled;
            });
        }

        /**
         * Set the child collection for the current. The models in this collection have to be an categories.
         * @param childCollection
         */
        public setChildCollection<C>(childCollection: ICollectionBase<C>): void {
            this.childCollection = childCollection;
        }

        /**
         * Sets the parent collection for the current collection and Class which is used for the population
         * child models to the parent
         * @param parentCollection
         * @param populateClass
         */
        public setParentCollection<C>(parentCollection: ICollectionBase<C>, populateClass: ICollectionPopulate | ICollectionPopulateStatic): void {
            if (typeof (<ICollectionPopulate>populateClass).populate === 'function') {
                this.populateClass = populateClass as ICollectionPopulate;
            } else {
                this.populateClass = new (<ICollectionPopulateStatic>populateClass)(parentCollection, this);
            }
            this.parentCollection = parentCollection;
            parentCollection.setChildCollection(this);
        }

        public filterList(): void {
            this.filteredModelsList = this.allModelsList;

            for (const filter of this.filters) {
                this.filteredModelsList = filter.filter(this.filteredModelsList);
            }

            if (this.childCollection) {
                this.childCollection.filterList();
            }

            if (this.parentCollection) {
                this.populateClass.populate();
            }
        }

        /**
         * returns the models from the child collection
         */
        public getLowLevelModels(): CollectionModel<T>[] {
            return this.childCollection ? this.childCollection.getLowLevelModels() : this.models;
        }

        public addFilters(...filters: IInteractiveFilter[]): void {

            filters.forEach((filter) => {
                filter.on('change', () => this.filterList());
            });

            this.filters.push(...filters);
        }

        public removeParent(): void {
            this.populateClass = null;
            if (this.parentCollection) {
                this.parentCollection.childCollection = null;
            }
            this.parentCollection = null;
        }

        public get(id: ModelValueType): ISmartMoverModel<T> {
            return this.models.filter((model) => model.id === id)[0];
        }
    }
}
